import React, {Component} from "react";
import {connect} from "react-redux";
import {OTSession, OTStreams} from "opentok-react";
import OT from "@opentok/client";
import className from "classnames";
import * as actions from "../../actions";
import {TOKBOX_APIKEY} from "../../util/constants";
import Publisher from "../../components/tokbox/Publisher";
import Subscriber from "../../components/tokbox/Subscriber";
import LiveChat from "../../components/tokbox/LiveChat";
import VideoTabBarButton from "../../components/tokbox/VideoTabBarButton";
import ExitSessionModal from "../../components/modal/ExitSessionModal";
import {checkValidBroadcast} from "../../util/broadcast/start_broadcast";
import {
    hideModal,
    isEmpty,
    LogException,
    makeUserOnline,
    navigate,
    removeAllModalPopUps,
    showModal,
    vuepayAlert,
    vuePayLog,
} from "../../util/utility";
import {getData, LOGIN, USER_DATA} from "../../util/storage";
import {decodeEncryptedIdForBroadcaster, getEncryptedIdForBroadcaster,} from "../../util/broadcast_util";
import {requestFullScreen} from "../../util/broadcast/countdown";
import {getConnectionObject, getSignalObject, removeConnectionObject,} from "../../util/broadcast/common";
import InviteForSessionModal from "../../components/modal/InviteForSessionModal";
import {
    createBroadcastOnFirestore,
    createPrivateSessionRecord,
    subscribeToFireStore,
    unsubscribeToFireStore,
} from "../../util/firebase/firestore";
import * as _ from "lodash";
import {updateJWTToken} from "../../util/broadcast/create";
import {checkIfCreatePrivateBroadcast} from "../../util/broadcast";
import CommonModal from "../../components/modal/CommonModal";
import cross from "../../assets/images/cross.svg";
//import cross from "../../assets/images/followers2.png";
import "../../assets/css/videoScreen.css";
import {Col, Row} from "reactstrap";
import TipIcon from "../../assets/images/tip_with_blue_bg.svg";
import TipListModal from "../../components/modal/TipListModal/TipListModal";
import ButtonDesign from "../../components/ButtonDesign";

class AvailabilityBroadcast extends Component {
  constructor(props) {
    super(props);

    this.publisherRef = null;
    this.otSession = React.createRef();
    this.state = {
      api_key: TOKBOX_APIKEY,
      broadcast: null,
      videoDevices: [],
      audioDevices: [],
      broadcast_id: null,
      session_id: null,
      token: null,
      error: null,
      connected: false,
      video: true,
      audio: true,
      screenShare: false,
      modal: false,
      inviteSessionModal: false,
      sessionHelper: null,
      elapsed_time: "00:00",
      connectionArray: [],
      OTSessionConnection: [],
      signalArray: [],
      tabActiveIndex: 1,
      clicked_user_details: null,
      currency_symbol: "£",
      total: "0.00",
      private_broadcast_id: -1,
      groupRequest: [],
      oneToOneRequest: [],
      viewerLeftSession: false,
      privateRequestSentToViewer: false,
      userDataOfPrivateRequestSentToViewer: null,
      viewerAcceptedPrivateRequest: false,
      viewer_id: -1,
      is_invite_sent: false,
      commonModalMsg:
        "You cannot send more than one private request, please wait while the viewer accepts/reject your request.",
      togglePubSubState: false,
      isPrivateSession: true,
      isFullScreen: false,
      globalPublisher: null,
      videoSource: null,
      audioSource: null,
      videoSourceIndex: -1,
      audioSourceIndex: 0,
      videoScreenToggle: false,
      countdown: 30,
      viewerProfile: null,
      privateSessionDetail: null,
      requestType: null,
    };

    // 30 Sec set timeout Timer Code
    this.timer = setInterval(
      () => this.state.requestType === "onetoone" && this.tick(),
      props.timeout || 1000
    );

    this.sessionEvents = {
      sessionConnected: () => {
        this.setState({ connected: true });
      },
      sessionDisconnected: () => {
        this.setState({ connected: false });
      },
    };

    //all the functions used in this component should be listed here for better documentation
    this.setOTSession = this.setOTSession.bind(this);
    this.onError = this.onError.bind(this);
    this.disconnectOTSession = this.disconnectOTSession.bind(this);
    this.navigateUserOut = this.navigateUserOut.bind(this);
    this.toggleVideo = this.toggleVideo.bind(this);
    this.toggleAudio = this.toggleAudio.bind(this);
    this.toggleScreenShare = this.toggleScreenShare.bind(this);
    this.togglePubSub = this.togglePubSub.bind(this);
    this.toggleFull = this.toggleFull.bind(this);
    this.requestFullScreen = this.requestFullScreen.bind(this);
    this.toggleEndSessionModal = this.toggleEndSessionModal.bind(this);
    this.toggleInviteForSessionModal = this.toggleInviteForSessionModal.bind(
      this
    );
    this.disconnectFromTokBoxAndChangeBroadcast = this.disconnectFromTokBoxAndChangeBroadcast.bind(
      this
    );
    this.disconnectFromTokBoxAndChangeBroadcastToPrivate = this.disconnectFromTokBoxAndChangeBroadcastToPrivate.bind(
      this
    );
    this.escFunction = this.escFunction.bind(this);
  }

  //timeout code
  tick() {
    const current = this.state.privateSessionDetail && this.state.countdown;
    if (current === 0) {
      this.transition();
    } else {
      this.setState({
        countdown: this.state.privateSessionDetail ? current - 1 : 0,
      });
    }
  }

  transition() {
    clearInterval(this.timer);
    this.setState({ videoScreenToggle: true });
    getData(LOGIN).then((data) => {
      if (!isEmpty(data)) {
        const request_id = this.state.broadcasterRequestId;

        this.props.broadcasterTimeoutRequest(
          data.token,
          data.api_token,
          this.props.location.state.requestId,
          // this.props.account_management.userDetails.broadcaster[0]
          //   .availability[0].id
          this.props.location.state.broadcast_id
        );
      }
    });
  }

  changeAudio = (index) => {
    if (this.publisherRef) {
      let publisher = this.publisherRef.current.getPublisher();
      publisher.setAudioSource(this.state.audioDevices[index]["deviceId"]);
    }
    this.setState({
      audioSource: this.state.audioDevices[index]["deviceId"],
      audioSourceIndex: index,
    });
  };

  changeVideo = (index) => {
    this.setState({
      videoSource: this.state.videoDevices[index]["deviceId"],
      videoSourceIndex: index,
    });
  };

  videoDimensions = (video) => {
    try {
      // Ratio of the video's intrinsic dimensions
      let videoRatio = video.videoWidth / video.videoHeight;
      // The width and height of the video element
      let width = video.offsetWidth,
        height = video.offsetHeight;
      // The ratio of the element's width to its height
      let elementRatio = width / height;

      return {
        width: width,
        height: height,
      };
      // If the video element is short and wide
      //if (elementRatio > videoRatio) width = height * videoRatio;
      // It must be tall and thin, or exactly equal to the original ratio
      //else height = width / videoRatio;
    } catch (e) {
    }
  };

  setVideoCloseFrame = () => {
    let parent = document.getElementsByClassName("OT_widget-container")[0],
      video = document.getElementsByClassName("OT_video-element")[0],
      frame = document.createElement("div");

    if (!video) {
      return;
    }

    let dimension = this.videoDimensions(video);
    let frameDimension = {
      //width: (dimension.height * 9) / 16,
      width:
        (document.getElementsByClassName("video-container")[0].offsetHeight *
          9) /
        16,
      height: dimension.height,
      left: 0,
    };

    //frameDimension.left = (dimension.width - frameDimension.width) / 2
    frameDimension.left =
      (document.getElementsByClassName("video-container")[0].offsetWidth -
        frameDimension.width) /
      2;

    if (document.getElementById("OT_video-element-frame")) {
      document.getElementById("OT_video-element-frame").remove();
    }

    frame.setAttribute("id", "OT_video-element-frame");
    frame.style.cssText =
      "position: absolute;" +
      "top: 0;" +
      "left: " +
      frameDimension.left +
      "px;" +
      "z-index: 1;" +
      "width: " +
      frameDimension.width +
      "px;" +
      //"height: " + frameDimension.height + "px;" +
      "height: " +
      document.getElementsByClassName("video-container")[0].offsetHeight +
      "px;" +
      "border:2px dashed #1B75BC;";

    let img = document.createElement("img");
    img.style.cssText = "position: absolute;top: 0px;left: -16px;";
    img.src = cross;
    img.onclick = function () {
      document.getElementById("OT_video-element-frame").style.display = "none";
    };

    frame.appendChild(img);
    parent.appendChild(frame);
  };

  checkValidBroadcast() {
    //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
    checkValidBroadcast(this.props.location)
      .then((broadcastDetail) => {
        this.setState(
          {
            broadcast_id: decodeEncryptedIdForBroadcaster(
              broadcastDetail.broadcast_id
            ),
            private_broadcast_id: broadcastDetail.hasOwnProperty(
              "private_broadcast_id"
            )
              ? decodeEncryptedIdForBroadcaster(
                  broadcastDetail.private_broadcast_id
                )
              : -1,
            session_id: broadcastDetail.session_id,
            token: broadcastDetail.token,
          },
          () => {
            if (this.state.broadcast_id === -1) {
              //TODO
              //there is some URL manipulation done show error and navigate the user out of this screen
              this.props.history.push("/broadcaster/availability");
            }
          }
        );
      })
      .catch((err) => {
        this.props.showLeftBar(); //show the leftbar
        LogException("AvailabilityBroadcast", "checkValidBroadcast", err);
        this.navigateUserOut(
          "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later."
        );
      });
  }

  /**
   * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
   * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
   */
  componentDidMount() {

    this.checkValidBroadcast();

    this.props.hideLeftBar(); //hide the leftbar
    this.props.hideSearchBar(); //hide the Search bar

    document.addEventListener("fullscreenchange", this.escFunction);
    document.addEventListener("webkitfullscreenchange", this.escFunction);
    document.addEventListener("mozfullscreenchange", this.escFunction);
    document.addEventListener("MSFullscreenChange", this.escFunction);

    this.setState({
      requestType: this.props.location.state.requestType,
    });
    try {
      OT.getDevices((error, devices) => {
        if (error) {
          return;
        }
        const audioDeviceIds = devices.filter((e) => e.kind == "audioInput");
        const videoDeviceIds = devices.filter((e) => e.kind == "videoInput");

        this.setState({
          videoDevices: videoDeviceIds,
          audioDevices: audioDeviceIds,
        });
      });
    } catch (e) {
      LogException("start_broadcast", "componentDidMount", e);
    }
  }

  /**
   * @function This method is called when a component is being removed from the DOM
   * so we have to unsubscribe to all events & disconnect from OT Session
   */
  componentWillUnmount() {
    this.disconnectOTSession();
    unsubscribeToFireStore(this.state.broadcast_id);
    this.props.showSearchBar(); //Show the Search bar
    document.addEventListener("fullscreenchange", this.escFunction);
    document.addEventListener("webkitfullscreenchange", this.escFunction);
    document.addEventListener("mozfullscreenchange", this.escFunction);
    document.addEventListener("MSFullscreenChange", this.escFunction);
  }

  /**
   * @function This is invoked when an update is caused by changes to props or state.
   * These methods are called when a component is being re-rendered
   * @param nextProps
   */
  UNSAFE_componentWillReceiveProps(nextProps) {
    //get viewer profile details
    let viewer = nextProps.availability.oneToOneAvailabilityList.filter(
      (req) => req.id == this.props.location.state.requestId
    );
    viewer.length > 0 &&
      this.setState({
        viewerProfile: viewer[0],
      });

    //set viewer profile picture
    let element = document.getElementsByClassName("OT_video-poster");
    this.state.requestType === "onetoone" &&
      viewer[0] &&
      element.length > 0 &&
      (element[0].style.backgroundImage =
        "url('" + viewer[0].profile_pic + "')");

    this.props.availability.privateAvailabilityList.length > 0 &&
      this.setState({
        privateSessionDetail: this.props.availability
          .privateAvailabilityList[0],
        countdown: parseInt(
          this.props.availability.privateAvailabilityList[0]
            .wait_time_in_seconds
        ),
      });

    if (
      nextProps.broadcaster_detail_management &&
      nextProps.broadcaster_detail_management.broadcastDetail != null
    ) {
      if (
        nextProps.broadcaster_detail_management.broadcastDetail.hasOwnProperty(
          "data"
        ) &&
        nextProps.broadcaster_detail_management.broadcastDetail.data.length > 0
      ) {
        this.setState(
          {
            broadcast:
              nextProps.broadcaster_detail_management.broadcastDetail.data[0],
          },
          () => {
            if (
              this.state.broadcast.hasOwnProperty("broadcast_end_at") &&
              this.state.broadcast.broadcast_end_at !== null
            ) {
              /**
               * @business_rule
               * listener for group & one to one request
               */
              if (Array.isArray(this.state.broadcast.private)) {
                subscribeToFireStore(
                  this.state.broadcast_id,
                  this.onGroupRequestUpdate,
                  this.onOneToOneRequestUpdate
                );
              }

              if (
                this.state.broadcast.private.hasOwnProperty("end_at") &&
                this.state.broadcast.private.end_at !== null
              ) {
                vuepayAlert("error", "Private session has ended!", () => {
                  navigate(this.props, "broadcaster_availability");
                });
              }

              return;
            }

            if (Array.isArray(this.state.broadcast.private)) {
              createBroadcastOnFirestore(
                this.state.broadcast_id,
                {
                  broadcast_type: this.state.broadcast.broadcast_type,
                  group_session_price: this.state.broadcast.group_session_price,
                  one_to_one_session_allow: this.state.broadcast
                    .one_to_one_session_allow,
                  one_to_one_session_price: this.state.broadcast
                    .one_to_one_session_price,
                  session_description: this.state.broadcast.session_description,
                  session_title: this.state.broadcast.session_title,
                },
                () => {
                  /**
                   * @business_rule
                   * listener for group & one to one request
                   */

                  subscribeToFireStore(
                    this.state.broadcast_id,
                    this.onGroupRequestUpdate,
                    this.onOneToOneRequestUpdate
                  );
                }
              );
            }
          }
        );
      } else if (
        nextProps.broadcaster_detail_management.broadcastDetail.error != null
      ) {
        //get the user out of this screen
        this.navigateUserOut(
          nextProps.broadcaster_detail_management.broadcastDetail.error.message
        );
      }

      this.props.resetBroadcastDetail();
    }

    if (
      nextProps.account_management &&
      nextProps.account_management.userDetails &&
      nextProps.account_management.userDetails.broadcaster.length > 0 &&
      nextProps.account_management.userDetails.broadcaster[0].availability
        .length > 0 &&
      nextProps.account_management.userDetails.broadcaster[0].availability[0]
        .broadcast.length > 0 &&
      this.state.broadcast == null
    ) {
      this.setState(
        {
          broadcast:
            nextProps.account_management.userDetails.broadcaster[0]
              .availability[0].broadcast[0],
        },
        () => {
        }
      );

      // this.props.resetBroadcastDetail();
    }

    if (
      nextProps.get_broadcast_earnings !== null &&
      nextProps.get_broadcast_earnings.hasOwnProperty("payload") &&
      nextProps.get_broadcast_earnings.payload !== null
    ) {
      const payload = nextProps.get_broadcast_earnings.payload;
      this.props.resetGetBroacastEarnings();

      //if the status_code received from the server is 200 means the user has successfully done the forgot password
      if (payload.status_code === 200) {
        //update the user earnings
        this.setState({
          currency_symbol: payload.currency_symbol,
          total: payload.total,
        });
      } else {
        //if the status_code received from the server is NOT 200 means there has been some error occurred
        vuepayAlert("error", payload.message);
      }
    }

    //check Favourite
    if (
      nextProps.hasOwnProperty("broadcaster_favourites") &&
      nextProps.broadcaster_favourites.hasOwnProperty(
        "favourite_unfavourite_data"
      ) &&
      nextProps.broadcaster_favourites.favourite_unfavourite_data != null &&
      nextProps.broadcaster_favourites.favourite_unfavourite_data.hasOwnProperty(
        "success"
      ) &&
      !nextProps.broadcaster_favourites.isFetching &&
      nextProps.broadcaster_favourites.isSuccess
    ) {
      let index = _.findIndex(this.state.connectionArray, {
        id: this.state.clicked_user_details.id,
      });

      const connectionArray = this.state.connectionArray;
      if (connectionArray[index].userData.is_favorite === "false") {
        connectionArray[index].userData.is_favorite = "true";
      } else {
        connectionArray[index].userData.is_favorite = "false";
      }
      this.setState(
        {
          connectionArray: connectionArray,
          clicked_user_details: connectionArray[index],
        },
        () => {
          this.toggleInviteForSessionModal();
        }
      );

      this.props.resetFavouritesUnFavouriteData();
    }

    /**
     * if a broadcaster has accepted a private request invite then this is called
     */
    if (checkIfCreatePrivateBroadcast(nextProps)) {
      const payload = nextProps.broadcast.private_broadcast_payload;
      //if the status_code received from the server is 201 means the broadcast was created successfully

      updateJWTToken(payload, () => {
        // add paid group node in firestore
        if (this.state.viewerAcceptedPrivateRequest) {
          createPrivateSessionRecord(
            this.state.broadcast.id.toString(),
            payload.data.id.toString(),
            this.state.viewer_id.toString(),
            () => {
              this.disconnectFromTokBoxAndChangeBroadcastToPrivate(
                payload.data
              );
            }
          );
        }
        // else {
        //
        //   updatePrivateSessionRequestStatus(
        //     // this.state.broadcast.id.toString(),
        //     this.props.location.state.broadcast_id.toString(),
        //     this.state.viewer_id.toString(),
        //     1,
        //     () => {
        //       createPrivateSessionRecord(
        //         // this.state.broadcast.id.toString(),
        //         this.props.location.state.broadcast_id.toString(),
        //         payload.data.id.toString(),
        //         this.state.viewer_id.toString(),
        //         () => {
        //           this.disconnectFromTokBoxAndChangeBroadcastToPrivate(
        //             payload.data
        //           );
        //         }
        //       );
        //     }
        //   );
        // }
      });
      vuepayAlert("success", payload.message);
      nextProps.resetPrivateBroadcast();
    }
  }

  onGroupRequestUpdate = (querySnapshot) => {
    let groupRequest = [];
    querySnapshot.forEach((doc) => {
      groupRequest.push(doc.data());
    });

    this.setState({
      groupRequest: groupRequest,
    });
  };

  onOneToOneRequestUpdate = (querySnapshot) => {
    let oneToOneRequest = [];
    querySnapshot.forEach((doc) => {
      if (
        doc.exists &&
        doc.data().from === "broadcaster" &&
        doc.data().status === 1
      ) {
        getData(LOGIN).then((data) => {
          if (!isEmpty(data)) {
            const jsonData = {
              device: this.props.device,
              broadcast_id: this.state.broadcast_id,
            };
            this.setState(
              {
                viewerAcceptedPrivateRequest: true,
                viewer_id: doc.id,
              },
              () => {
                this.props.createPrivateBroadcast(
                  data.token,
                  data.api_token,
                  jsonData
                );
              }
            );
          }
        });
      }
      oneToOneRequest.push({ ...doc.data(), id: doc.id });
    });

    this.setState({
      oneToOneRequest: oneToOneRequest,
    });
  };

  navigateUserOut = (message) => {
    vuepayAlert("error", message, () => {
      navigate(this.props, "broadcaster_availability");
    });
  };

  disconnectOTSession = () => {
    if (this.otSession && this.otSession.current !== null) {
      this.otSession.current.sessionHelper.session.disconnect();
    }
  };

  disconnectOTSessionAndNavigateToHomeScreen = () => {
    if (this.otSession && this.otSession.current !== null) {
      this.otSession.current.sessionHelper.session.disconnect();
      removeAllModalPopUps();
      getData(USER_DATA).then((data) => {
        ////console.log(data)
        if (!isEmpty(data)) {
          makeUserOnline(data.user_id);
        }
      });
      navigate(this.props, "broadcaster_availability");
      window.location.reload();
    }
  };

  onError = (err) => {
    console.error(err);
    this.setState({ error: `Failed to connect: ${err.message}` });
  };

  setOTSession = (session) => {
    this.setState({
      sessionHelper: session,
    });

    this.otSession.current.sessionHelper.session.on(
      "sessionDisconnected",
      (event) => {
        ////console.log("sessionDisconnected");
        ////console.log(event);

        if (
          event.hasOwnProperty("reason") &&
          event.reason === "forceDisconnected"
        ) {
          this.disconnectOTSession();
          vuepayAlert(
            "error",
            "Your session has been ended by VuePay, as viewers have reported against this broadcast."
          );
          navigate(this.props, "broadcaster_availability");
        }
      }
    );

    this.otSession.current.sessionHelper.session.on(
      "connectionCreated",
      (event) => {
        //a publisher is a part of connection so lets avoid his VIEW count
        if (
          this.otSession.current.sessionHelper.session.connection
            .connectionId !== event.connection.connectionId
        ) {
          let connectionArray = this.state.connectionArray,
            OTSessionConnection = this.state.OTSessionConnection;
          const connection = getConnectionObject(event);

          const found = connectionArray.find(
            (element) => element.connectionId === connection.connectionId
          );
          if (!found) {
            connectionArray.push(connection);
          }

          //this OTSessionConnectionArray is used only of the broadcaster request to block a user
          OTSessionConnection[connection.userData.user_api_id] =
            event.connection;

          this.setState({
            connectionArray: connectionArray,
            OTSessionConnection: OTSessionConnection,
          });
        }
      }
    );

    this.otSession.current.sessionHelper.session.on(
      "connectionDestroyed",
      (event) => {
        // console.log("connectionDestroyed");
        // console.log(event);
        if (event.reason === "clientDisconnected") {
          if (this.state.private_broadcast_id !== -1) {
            this.setState(
              {
                viewerLeftSession: true,
              },
              () => {
                ////console.log(this.state.viewerLeftSession)
                // this.toggleEndSessionModal()  // commented this method because connectionDestroyed event firing two times which hide leave session modal
                // implemented below code to stop toggling over two times firing connectionDestroyed
                const modal = document.getElementById("end-broadcast-session");
                showModal(modal);
              }
            );
          }
        }

        let connectionArray = this.state.connectionArray;
        connectionArray = removeConnectionObject(event, connectionArray);
        this.setState({
          connectionArray: connectionArray,
        });
      }
    );

    this.otSession.current.sessionHelper.session.on("signal", (event) => {
      let signalArray = this.state.signalArray;
      const signal = getSignalObject(event);

      const found = signalArray.find(
        (element) =>
          element.connectionId === signal.connectionId &&
          element.text === signal.text
      );
      if (!found) {
        signalArray.push(signal);
        this.setState({
          signalArray: signalArray,
        });
      }
    });

    if (this.state.private_broadcast_id === -1) {
      this.setVideoCloseFrame();
    }

    let ref = this;
    window.addEventListener("resize", function (e) {
      if (ref.state.private_broadcast_id === -1) {
        ref.setVideoCloseFrame();
      }
    });
  };

  setElapsedTime = (time) => {
    this.setState(
      {
        elapsed_time: time,
      },
      () => {
        /**
         * @business_rule
         * check if the seconds count is 59 then
         */
        const timeArray = time.split(":"),
          seconds = timeArray[1];

        if (parseInt(seconds) % 59 === 0) {
          /**
           * @Webservice GET earnings for a private or group broadcast
           */
          getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
              if (this.state.private_broadcast_id === -1) {
                if (this.state.broadcast.broadcast_type === "paid") {
                  this.props.getBroacastEarnings(
                    data.token,
                    data.api_token,
                    "group",
                    this.state.broadcast.id
                  );
                }
              } else {
                this.props.getBroacastEarnings(
                  data.token,
                  data.api_token,
                  "private",
                  this.state.private_broadcast_id
                );
              }
            }
          });
        }
        // }
      }
    );
  };

  setUserData = (connection) => {
    let index = _.findIndex(this.state.connectionArray, { id: connection.id });
    this.setState(
      {
        clicked_user_details: this.state.connectionArray[index],
      },
      () => {
        //console.log("this.state.clicked_user_details",this.state.clicked_user_details)
        if (
          this.state.clicked_user_details !== undefined &&
          this.state.clicked_user_details !== null &&
          this.state.clicked_user_details.hasOwnProperty("userData") &&
          this.state.clicked_user_details.userData.hasOwnProperty("user_api_id")
        ) {
          const user_api_id = this.state.clicked_user_details.userData
            .user_api_id;
          const index = _.findIndex(this.state.oneToOneRequest, function (o) {
            return o.id === user_api_id;
          });
          if (index >= 0) {
            this.setState({
              is_invite_sent:
                this.state.oneToOneRequest[index].from === "broadcaster",
            });
          }
        }
      }
    );
  };

  toggleVideo() {
    this.setState({
      video: !this.state.video,
    });
  }

  toggleAudio() {
    this.setState({
      audio: !this.state.audio,
    });
  }

  toggleScreenShare() {
    if (this.state.screenShare) {
      //user is already sharing the screen
      this.changeVideo(0);
      this.setState({
        audioSource: null,
        screenShare: false,
      });
    } else {
      let ref = this;
      OT.checkScreenSharingCapability(function (response) {
        if (!response.supported || response.extensionRegistered === false) {
          // This browser does not support screen sharing
          //console.log("This browser does not support screen sharing")
        } else if (response.extensionInstalled === false) {
          // Prompt to install the extension
          //console.log("Prompt to install the extension")
        } else {
          // Screen sharing is available.
          //console.log("Screen sharing is available.")
          // ref.setState({
          //     screenShare: !ref.state.screenShare
          // });

          Promise.all([
            OT.getUserMedia({
              videoSource: "screen",
            }),
            OT.getUserMedia({
              videoSource: null,
            }),
          ]).then(([screenStream, micStream]) => {
            // return OT.initPublisher(null, {
            //     videoSource: screenStream.getVideoTracks()[0],
            //     audioSource: micStream.getAudioTracks()[0]
            // });

            if (
              screenStream !== null &&
              Array.isArray(screenStream.getVideoTracks())
            ) {
              if (
                micStream !== null &&
                Array.isArray(micStream.getAudioTracks())
              ) {
                ref.setState({
                  videoSource: screenStream.getVideoTracks()[0],
                  audioSource: micStream.getAudioTracks()[0],
                  screenShare: true,
                });
              } else {
                alert("Couldn't get your audio track");
              }
            } else {
              alert("Couldn't get your video track");
            }
          });
        }
      });
    }
  }

  toggleEndSessionModal = () => {
    const modal = document.getElementById("end-broadcast-session");
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        this.state.modal ? showModal(modal) : hideModal(modal);
      }
    );
  };

  toggleCommonModal = () => {
    const modal = document.getElementById("common-modal");
    this.setState(
      {
        modal: !this.state.modal,
      },
      () => {
        this.state.modal ? showModal(modal) : hideModal(modal);
      }
    );
  };

  toggleInviteForSessionModal = () => {
    setTimeout(() => {
      const modal = document.getElementById("invite-for-session");
      this.setState(
        {
          inviteSessionModal: !this.state.inviteSessionModal,
        },
        () => {
          this.state.inviteSessionModal ? showModal(modal) : hideModal(modal);
        }
      );
    }, 200); //delay for the modal to come into memory
  };

  requestFullScreen = () => {
    //const video = document.getElementsByClassName("OT_video-element")[0];
    // const video = document.getElementsByClassName("OT_video-element")[
    //     (document.getElementsByClassName("OT_video-element").length > 1) ?
    //         1 : 0
    //     ];
    const video = document.getElementsByClassName("video-container")[0];
    this.setState({ isFullScreen: true }, () => {
      requestFullScreen(video);
      document.getElementsByClassName("video-container")[0].style.width =
        "100%";
      setTimeout(() => {
        this.toggleFull();
        if (document.getElementById("OT_video-element-frame")) {
          document.getElementById("OT_video-element-frame").style.zIndex =
            "-10";
        }
      }, 1000);
    });
  };

  escFunction = (event) => {
    if (
      !document.fullscreenElement &&
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      this.setState({ isFullScreen: false }, () => {
        //console.log("exit fullscreen mode")
        setTimeout(() => {
          this.toggleFull();
          if (document.getElementById("OT_video-element-frame")) {
            document.getElementById("OT_video-element-frame").style.zIndex =
              "1";
          }
        }, 1000);
      });
    }
  };

  setTabActiveIndex = (index) => {
    this.setState({
      tabActiveIndex: index,
    });
  };

  createBroadcast = (token, api_token, formData) => {
    this.props.createBroadcast(token, api_token, formData);
  };

  disconnectFromTokBoxAndChangeBroadcast = (data) => {
    const waitForDisconnect = 500; //0.5 secs
    this.disconnectOTSession();
    setTimeout(() => {
      //create broadcast
      const broadcastID = getEncryptedIdForBroadcaster(data.id);
      removeAllModalPopUps();
      const path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}`;

      this.props.history.push(path, {
        session_id: data.session_id,
        broadcast_id: data.id,
        token: data.token,
      });

      window.location.href = path;
    }, waitForDisconnect);
  };

  setInteractedViewerID = (viewer_id) => {
    this.setState({
      viewer_id: viewer_id,
    });
  };

  disconnectFromTokBoxAndChangeBroadcastToPrivate = (data) => {
    const waitForDisconnect = 500; //0.5 secs
    this.disconnectOTSession();
    setTimeout(() => {
      //create broadcast
      const broadcastID = getEncryptedIdForBroadcaster(this.state.broadcast_id);
      const private_broadcast_id = getEncryptedIdForBroadcaster(data.id);

      removeAllModalPopUps();

      const path = `/broadcaster/start/broadcast?session_id=${data.session_id}&broadcast_id=${broadcastID}&token=${data.token}&private_broadcast_id=${private_broadcast_id}`;
      this.props.history.push(path, {
        session_id: data.session_id,
        broadcast_id: data.id,
        token: data.token,
      });

      window.location.href = path;
    }, waitForDisconnect);
  };

  favouriteUnFavouriteUser = () => {
    if (this.state.clicked_user_details) {
      const user = this.state.clicked_user_details.userData;
      getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
          if (user.is_favorite === "true") {
            this.props.unFavouriteViewer(
              data.token,
              data.api_token,
              user.user_api_id
            );
          } else {
            this.props.favouriteViewer(
              data.token,
              data.api_token,
              user.user_api_id
            );
          }
        }
      });
    }
  };

  blockOnUnblockViewer = () => {
    if (this.state.clicked_user_details) {
      const user = this.state.clicked_user_details.userData;
      getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
          if (user.hasOwnProperty("is_blocked")) {
            if (user.is_blocked === "true") {
              this.props.unBlockViewer(
                data.token,
                data.api_token,
                user.user_api_id
              );
            } else {
              this.props.blockViewer(
                data.token,
                data.api_token,
                user.user_api_id
              );
            }
          } else {
            this.props.blockViewer(
              data.token,
              data.api_token,
              user.user_api_id
            );
          }
        }
      });

      if (
        this.otSession.current.sessionHelper.session.capabilities
          .forceDisconnect == 1
      ) {
        // The client can forceDisconnect. See the next section.
        ////console.log("The client can forceDisconnect.");
        this.otSession.current.sessionHelper.session.forceDisconnect(
          this.state.OTSessionConnection[user.user_api_id]
        );
        if (
          !isEmpty(this.state.clicked_user_details.userData.private_session_id)
        ) {
          //disconnect the entire session if session is private
          this.disconnectOTSessionAndNavigateToHomeScreen();
          //navigate(this.props,"broadcaster_create_broadcast");
        }
      } else {
        // The client cannot moderate.
        ////console.log("The client cannot moderate.");
      }
    }
  };

  /**
   * @function is invoked immediately When Publisher is unable to publish due to any reason
   */
  onPublishError = (e) => {
    vuePayLog("AvailabilityBroadcast", "onError", e);
    this.disconnectOTSessionAndNavigateToHomeScreen();
    navigate(this.props, "broadcaster_availability");
  };

  togglePubSub = () => {
    this.setState({ togglePubSubState: !this.state.togglePubSubState });
    //console.log("togglePubSubState", this.state.togglePubSubState);
    if (!this.state.togglePubSubState) {
      let chat_window = document.getElementById("chat-window");
      let sub_id = document.getElementById("sub-id");
      sub_id.className = "chat-window";
      document.getElementsByClassName("OTSubscriberContainer")[0].style.height =
        "150px";
      chat_window.className = "";
      document.getElementsByClassName(
        "OTPublisherContainer"
      )[0].style.height = `${
        document.getElementsByClassName("video-container")[0].offsetHeight
      }px`;

      this.setState({ isPrivateSession: false });
    } else {
      let chat_window = document.getElementById("chat-window");
      let sub_id = document.getElementById("sub-id");
      sub_id.className = "";
      document.getElementsByClassName(
        "OTSubscriberContainer"
      )[0].style.height = `${
        document.getElementsByClassName("video-container")[0].offsetHeight
      }px`;
      chat_window.className = "chat-window";
      document.getElementsByClassName("OTPublisherContainer")[0].style.height =
        "150px";

      this.setState({ isPrivateSession: true });
    }
  };

  toggleFull = () => {
    //console.log("toggleFull togglePubSubState", this.state.togglePubSubState);
    if (this.state.togglePubSubState) {
      if (this.state.private_broadcast_id !== -1) {
        let chat_window = document.getElementById("chat-window");
        let sub_id = document.getElementById("sub-id");
        sub_id.className = "chat-window";
        document.getElementsByClassName(
          "OTSubscriberContainer"
        )[0].style.height = "150px";
        chat_window.className = "";
        document.getElementsByClassName(
          "OTPublisherContainer"
        )[0].style.height = `${
          document.getElementsByClassName("video-container")[0].offsetHeight
        }px`;

        this.setState({ isPrivateSession: false });
      }
    } else {
      if (this.state.private_broadcast_id !== -1) {
        let chat_window = document.getElementById("chat-window");
        let sub_id = document.getElementById("sub-id");
        sub_id.className = "";
        document.getElementsByClassName(
          "OTSubscriberContainer"
        )[0].style.height = `${
          document.getElementsByClassName("video-container")[0].offsetHeight
        }px`;
        chat_window.className = "chat-window";
        document.getElementsByClassName(
          "OTPublisherContainer"
        )[0].style.height = "150px";

        this.setState({ isPrivateSession: true });
      }
    }
  };

  whenPrivateSession = () => {
    const subscriber = (
      <div id="chat-window" className="chat-window">
        <OTSession
          ref={this.otSession}
          apiKey={this.state.api_key}
          sessionId={this.state.session_id}
          token={this.state.token}
          eventHandlers={this.sessionEvents}
          onError={this.onError}
        >
          {this.showPublisher("private")}
        </OTSession>
      </div>
    );

    return subscriber;
  };

  showPublisherSubscriberSession = (isSubscribe = null) => {
    const session = (
      <OTSession
        ref={this.otSession}
        apiKey={this.state.api_key}
        sessionId={this.state.session_id}
        token={this.state.token}
        eventHandlers={this.sessionEvents}
        onError={this.onError}
      >
        {isSubscribe ? this.showSubscriber("private") : this.showPublisher()}
      </OTSession>
    );
    return session;
  };

  showPublisher = (isPrivate = null) => {
    const height =
      isPrivate && this.state.isPrivateSession
        ? "150px"
        : document.getElementsByClassName("video-container")[0] !== undefined
        ? `${
            document.getElementsByClassName("video-container")[0].offsetHeight
          }px`
        : "300px";
    const pub = (
      <Publisher
        setElapsedTime={this.setElapsedTime}
        isCountdownRequired={true}
        toggleEndSessionModal={() => this.toggleEndSessionModal}
        history={this.props.history}
        setOTSession={this.setOTSession}
        height={height}
        video={this.state.video}
        audio={this.state.audio}
        shareScreen={this.state.screenShare}
        videoSourceIndex={this.state.videoSourceIndex}
        audioSourceIndex={this.state.audioSourceIndex}
        videoSource={this.state.videoSource}
        audioSource={this.state.audioSource}
        onInit={(publisher) => {
          this.publisherRef = publisher;
        }}
        onPublish={() => {
          vuePayLog("AvailabilityBroadcast", "onPublish");
          setTimeout(() => {
            if (this.state.videoSourceIndex === -1) {
              this.changeVideo(0);
            }
          }, 1000);
          //do a delay and change the video to index
        }}
        onError={this.onPublishError}
        toggleScreenShare={this.toggleScreenShare}
      />
    );

    return pub;
  };

  showSubscriber = (isPrivate) => {
    const height = !isPrivate
      ? "150px"
      : document.getElementsByClassName("video-container")[0] !== undefined
      ? `${
          document.getElementsByClassName("video-container")[0].offsetHeight
        }px`
      : "300px";

    const sub = (
      <OTStreams>
        <Subscriber
          history={this.props.history}
          onSubscribe={() => vuePayLog("StartViewBroadcast", "onInit")}
          onError={(e) => vuePayLog("AvailabilityBroadcast", "onError", e)}
        >
          height={height}
        </Subscriber>
      </OTStreams>
    );

    return sub;
  };
  /**
   * @function toggles the state of dropdown menu
   */
  dropDownClickListener = () => {
    // document.getElementsByClassName("dropdown")[1].classList.toggle("show");
    document.getElementsByClassName("popover_menucontent")[1].classList.show();
    // this.state.globalPublisher.cycleVideo();
    // //console.log("working");
  };

  isBroadcasterVerified = () => {
    return (
      this.props.account_management.userDetails !== null &&
      this.props.account_management.userDetails !== undefined &&
      this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
      this.props.account_management.userDetails.broadcaster.length > 0 &&
      this.props.account_management.userDetails.broadcaster[0].is_verified === 1
    );
  };

  render() {
    const videoClass = className("btn-controls", "video", {
        active: this.state.video,
      }),
      audioClass = className("btn-controls", "volume", {
        active: this.state.audio,
      }),
      cameraToggle = className(
        "btn-controls",
        "cameraToggle",
        "popover__title",
        { active: this.state.videoSourceIndex !== 0 }
      ),
      audioToggle = className("btn-controls", "audioToggle", "popover__title"),
      screenShareClass = className("btn-controls", "screenShare", {
        active: this.state.screenShare,
      });

    const funForSessions = () => {
      return (
        <div id={"funForSessions"}>
          {this.whenPrivateSession()}
          {this.showPublisherSubscriberSession(true)}
        </div>
      );
    };

    return (
      <div>
        <CommonModal
          toggleCommonModal={this.toggleCommonModal}
          hideCrossButton={true}
          message={this.state.commonModalMsg}
        />

        <ExitSessionModal
          toggleEndSessionModal={this.toggleEndSessionModal}
          disconnectOTSession={this.disconnectOTSessionAndNavigateToHomeScreen}
          viewerLeftSession={this.state.viewerLeftSession}
          hideCrossButton={this.state.viewerLeftSession}
        />

        {this.state.clicked_user_details && (
          <InviteForSessionModal
            initialValues={this.state.broadcast}
            setInteractedViewerID={this.setInteractedViewerID}
            oneToOneRequestArray={this.state.oneToOneRequest}
            is_invite_sent={this.state.is_invite_sent}
            toggleInviteForSessionModal={this.toggleInviteForSessionModal}
            toggleCommonModal={this.toggleCommonModal}
            userDetails={this.state.clicked_user_details}
            broadcastId={this.state.broadcast_id}
            broadcast={this.state.broadcast}
            privateRequestSentToViewer={this.state.privateRequestSentToViewer}
            userDataOfPrivateRequestSentToViewer={
              this.state.userDataOfPrivateRequestSentToViewer
            }
            favouriteUnFavouriteUser={this.favouriteUnFavouriteUser}
            blockOnUnblockViewer={this.blockOnUnblockViewer}
          />
        )}

        <main
            role="main"
            className={className({
                "availability-flow": this.state.requestType && this.state.requestType === "onetoone"
            })}
        >
          {this.state.session_id !== null && (
            <div className="broadcast-container broadcasting">
              {/*video & live chat text row starts */}
              <div className="row">
                <div className="col-xl-8 col-lg12">
                  <div className="title-container mb-2">
                    {this.state.connectionArray.length > 0 &&
                    this.state.requestType === "onetoone" ? (
                      <div>
                        <p>Elapsed time: {this.state.elapsed_time} mins</p>
                      </div>
                    ) : (
                      <div>
                        <p>Elapsed time: {this.state.elapsed_time} mins</p>
                      </div>
                    )}
                    <div>
                      {this.state.private_broadcast_id !== -1 ? (
                        <p style={{ textAlign: "center" }}></p>
                      ) : (
                        <p style={{ textAlign: "center" }}>
                          {this.state.connectionArray.length} views
                        </p>
                      )}
                    </div>
                    {
                      <div>
                        <p className="follow">
                          {this.state.broadcast !== null &&
                          ((this.state.broadcast.hasOwnProperty(
                            "broadcast_type"
                          ) &&
                            this.state.broadcast.broadcast_type !== "free") ||
                            (this.state.broadcast.hasOwnProperty("private") &&
                              !Array.isArray(this.state.broadcast.private)))
                            ? this.props.get_broadcast_earnings.isFetching
                              ? "..."
                              : this.state.broadcast.broadcast_type === "free"
                              ? "Private free session"
                              : `Session earnings: ${this.state.currency_symbol}${this.state.total}`
                            : this.state.private_broadcast_id === -1
                            ? "Free session"
                            : "Private session"}
                        </p>
                        <ButtonDesign
                          btColor="primary"
                          btClass="mx-2 rounded-0"
                          onclickFunction={() => this.props.showTipListModal()}
                        >
                          <img
                            className="share-availability-icon"
                            src={TipIcon}
                          />
                        </ButtonDesign>
                      </div>
                    }
                  </div>
                </div>
                <div className="col-xl-4 d-none d-xl-block">
                  <div className="title-container mb-2">
                    <div>
                      <p>Live Chat</p>
                    </div>
                    {/*<div><p className="follow"><a href="" title="Hide">Hide</a></p></div>*/}
                  </div>
                </div>
              </div>
              {/*video & live chat text row ends */}

              {/*video & live chat row starts */}
              <div className="row">
                <div className="col-xl-8 col-lg12">
                  <div className="video-wrapper">
                    {/*video element starts */}

                    {this.state.videoScreenToggle ? (
                      <div className="video-container">
                        {/*after successfully joined screen*/}

                        <div className="control-panel">
                          <div
                            className={videoClass}
                            onClick={this.toggleVideo}
                          />
                          <div
                            className={audioClass}
                            onClick={this.toggleAudio}
                          />
                          <div
                            className={screenShareClass}
                            onClick={this.toggleScreenShare}
                          />
                          {this.state.audioDevices.length > 0 && (
                            <div className={"popover__wrapper btn-controls "}>
                              <div
                                className={[audioToggle]}
                                id="dropdownMenu3"
                              ></div>
                              <div className={"popover__content"}>
                                <ul
                                  className="popover_menucontent"
                                  aria-labelledby="myDropdown"
                                >
                                  {this.state.audioDevices.map(
                                    (device, index) => {
                                      return (
                                        <li
                                          className="camera-li"
                                          key={device.deviceId}
                                        >
                                          <a
                                            href="#"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              this.changeAudio(index);
                                            }}
                                            className="dropdown-item"
                                          >
                                            {device.label}
                                          </a>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            </div>
                          )}
                          <div className={"popover__wrapper btn-controls "}>
                            <div
                              className={[cameraToggle]}
                              id="dropdownMenu2"
                            ></div>
                            <div className={"popover__content"}>
                              <ul
                                className="popover_menucontent"
                                aria-labelledby="myDropdown"
                              >
                                {this.state.videoDevices.map(
                                  (device, index) => {
                                    return (
                                      <li
                                        className="camera-li"
                                        key={device.deviceId}
                                      >
                                        <a
                                          href="#"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            this.changeVideo(index);
                                          }}
                                          className="dropdown-item"
                                        >
                                          {device.label}
                                        </a>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </div>
                          </div>

                          {/* {(this.state.private_broadcast_id !== -1) && */}

                          {/* } */}

                          {/* <div className="btn-controls pause"></div> */}
                          {this.state.isFullScreen === false && (
                            <div
                              className="btn-controls cancel"
                              onClick={this.toggleEndSessionModal}
                            />
                          )}
                        </div>
                        {this.state.isFullScreen === false && (
                          <div
                            className="btn-controls fullscreen"
                            onClick={this.requestFullScreen}
                          />
                        )}
                        {this.state.private_broadcast_id !== -1
                          ? funForSessions()
                          : this.showPublisherSubscriberSession()}
                      </div>
                    ) : (
                      <div className="video-container">
                        {/*before Start calling 30 sec screen*/}
                        <div className="control-panel">
                          {this.state.requestType &&
                            this.state.requestType === "onetoone" && (
                              <React.Fragment>
                                <Col
                                  md="12"
                                  className="position-absolute bg-dark px-0 userIconPart"
                                >
                                  <span
                                    style={{
                                      color: "#FFFFFF",
                                      fontSize: "18px",
                                      margin: "0% 20%",
                                    }}
                                  >
                                    <i className="fa fa-user"></i>
                                  </span>
                                </Col>
                                <Col
                                  md="12"
                                  className="position-absolute bg-dark px-0 countingPart"
                                >
                                  <div
                                    style={{
                                      color: "#FFFFFF",
                                      fontFamily: "Open Sans",
                                      fontSize: "12px",
                                      letterSpacing: "0",
                                      lineHeight: "17px",
                                      margin: "10% 5%",
                                    }}
                                  >
                                    00:00:{this.state.countdown}
                                  </div>
                                </Col>
                                {this.state.connectionArray.length == 0 && (
                                  <Row className="position-absolute warningError">
                                    <Col>
                                      <p style={{ fontSize: 16 }}>
                                        {this.state.viewerProfile &&
                                          this.state.viewerProfile.title}
                                      </p>
                                      <p>
                                        {this.state.viewerProfile &&
                                          this.state.viewerProfile.message}
                                      </p>
                                    </Col>
                                  </Row>
                                )}
                              </React.Fragment>
                            )}
                          {this.state.broadcast.broadcast_type !== "free" && (
                            <Row className="position-absolute bg-dark earningPart">
                              <Col md="3" className="px-0">
                                <span
                                  style={{
                                    color: "#FFFFFF",
                                    fontSize: "18px",
                                    margin: "0% 20%",
                                  }}
                                  className="text-left"
                                >
                                  <i className="fa fa-user"></i>
                                </span>
                              </Col>
                              <Col md="9" className="px-0">
                                <div
                                  className="text-right"
                                  style={{
                                    color: "#FFFFFF",
                                    fontFamily: "Open Sans",
                                    fontSize: "12px",
                                    letterSpacing: "0",
                                    lineHeight: "17px",
                                    margin: "7% 5%",
                                  }}
                                >
                                  Earnings: 10.56
                                </div>
                              </Col>
                            </Row>
                          )}
                          <div
                            className={videoClass}
                            onClick={this.toggleVideo}
                          />
                          <div
                            className={audioClass}
                            onClick={this.toggleAudio}
                          />
                          <div
                            className={screenShareClass}
                            onClick={this.toggleScreenShare}
                          />
                          {this.state.audioDevices.length > 0 && (
                            <div className={"popover__wrapper btn-controls "}>
                              <div
                                className={[audioToggle]}
                                id="dropdownMenu3"
                              ></div>
                              <div className={"popover__content"}>
                                <ul
                                  className="popover_menucontent"
                                  aria-labelledby="myDropdown"
                                >
                                  {this.state.audioDevices.map(
                                    (device, index) => {
                                      return (
                                        <li
                                          className="camera-li"
                                          key={device.deviceId}
                                        >
                                          <a
                                            href="#"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              this.changeAudio(index);
                                            }}
                                            className="dropdown-item"
                                          >
                                            {device.label}
                                          </a>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            </div>
                          )}
                          <div className={"popover__wrapper btn-controls "}>
                            <div
                              className={[cameraToggle]}
                              id="dropdownMenu2"
                            ></div>
                            <div className={"popover__content"}>
                              <ul
                                className="popover_menucontent"
                                aria-labelledby="myDropdown"
                              >
                                {this.state.videoDevices.map(
                                  (device, index) => {
                                    return (
                                      <li
                                        className="camera-li"
                                        key={device.deviceId}
                                      >
                                        <a
                                          href="#"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            this.changeVideo(index);
                                          }}
                                          className="dropdown-item"
                                        >
                                          {device.label}
                                        </a>
                                      </li>
                                    );
                                  }
                                )}
                              </ul>
                            </div>
                          </div>

                          {/* {(this.state.private_broadcast_id !== -1) && */}

                          {/* } */}

                          {/* <div className="btn-controls pause"></div> */}
                          {this.state.isFullScreen === false && (
                            <div
                              className="btn-controls cancel"
                              onClick={this.toggleEndSessionModal}
                            />
                          )}
                        </div>
                        {this.state.isFullScreen === false && (
                          <div
                            className="btn-controls fullscreen"
                            onClick={this.requestFullScreen}
                          />
                        )}
                        {this.state.private_broadcast_id !== -1
                          ? funForSessions()
                          : this.showPublisherSubscriberSession()}
                      </div>
                    )}

                    {/*video element ends */}
                  </div>
                </div>

                {/* <div className="w-100 d-block d-xl-none mt-3"></div> */}

                {this.otSession.current !== null && (
                  <LiveChat
                    setUserData={this.setUserData}
                    toggleInviteForSessionModal={
                      this.toggleInviteForSessionModal
                    }
                    session={this.otSession.current.sessionHelper.session}
                    signalArray={this.state.signalArray}
                    userType={"Publisher"}
                    actionsAllowed={true}
                  />
                )}
              </div>

              {/*video & live chat row ends */}

              {/* <div className="w-100 d-block d-xl-none mt-3"></div> */}
            </div>
          )}
          <TipListModal
            showTipListModalFlag={this.props.showTipListModalFlag}
            hideTipListModal={this.props.hideTipListModal}
            tip={this.props.tip}
          />
        </main>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    account_management: state.account_management,
    broadcast: state.broadcast,
    get_broadcast_earnings: state.get_broadcast_earnings,
    broadcaster_detail_management: state.broadcaster_detail_management,
    broadcaster_favourites: state.broadcaster_favourites,
    broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
    device: state.device.payload,
    availability: state.availability,
  };
}

export default connect(mapStateToProps, actions)(AvailabilityBroadcast);
